module.exports = __webpack_public_path__ + "static/media/battery-half.562d1c3e.svg";